
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

const CourseDetailLoading = () => (
  <div className="container-custom py-16">
    <Skeleton className="h-64 w-full rounded-lg mb-6" />
    <Skeleton className="h-8 w-2/3 mb-4" />
    <Skeleton className="h-4 w-full mb-2" />
    <Skeleton className="h-4 w-1/2" />
  </div>
);

export default CourseDetailLoading;
